class calendrier extends ListeResultat {
	initialize(block, filtring) {
		let self = this;

		this.datePicker(block, filtring);
	}

	datePicker(selectorCalendar, classFiltring) {
		let self = this,
			now = new Date();

		///
		/// Function permettant de détecter 
		/// si le calendrier est sur le mois en cours ou non
		var testIfPrevMonthIsPast = function (obj) {
			let datePickerElement = document.querySelector('.datepicker');
			if (obj.currentMonth === now.getMonth() && obj.currentYear === now.getFullYear()) {
				datePickerElement.classList.add('is-current-month');
			} else {
				datePickerElement.classList.remove('is-current-month');
			}
		}

		/// On récupère la date si elle a été passée en paramètre de l'URL
		var getDateSelected = function (calendar) {
			let url = window.location.search.slice(2); // on récupère les paramètres
			let params = new URLSearchParams(url);
			let newDate = params.get('_date');
			if (newDate != null) {
				const [day, month, year] = newDate.split('/');
				let date = new Date(+year, month - 1, +day);
				if (now > date) {
					date = now;
				}
				return date;
			}
		}

		let options = {
			startDay: 1, // Calendar week starts on a Monday.
			customDays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sa'],
			customMonths: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			alwaysShow: true, // Never hide the calendar.
			maxDate: new Date(2099, 0, 1), // Jan 1st, 2099.
			minDate: now, // La date d'aujourd'hui
			//startDate: now, // This month.
			disableYearOverlay: true,
			showAllDates: true, // Numbers for leading & trailing days outside the current month will show.
			// customOverlayMonths: [],
			// overlayButton: 'Go!',
			// overlayPlaceholder: 'Enter a 4-digit year',
			dateSelected: getDateSelected(),
			// position: 'tr', // Top right.

			// Ne pas allez à un mois passé
			onMonthChange: instance => {
				testIfPrevMonthIsPast(instance);
			},
			onShow: instance => {
				testIfPrevMonthIsPast(instance);
				getDateSelected(instance);
			},
			// Au click sur une date
			onSelect: (instance, date) => {
				const dateSelectionne = new Intl.DateTimeFormat('fr-FR').format(instance.dateSelected);
				let dateDepartHidden = document.getElementById('dateDepartHidden');
				let selectFlexibilite = document.getElementById('flexibiliteLR');

				if (date != null && date != 'undefined') {
					dateDepartHidden.value = dateSelectionne;
					selectFlexibilite.value = 7;
					//selectFlexibilite.removeAttribute('disabled');
					self._getDate(filtres.json);
					classFiltring.reloadResultat();
				} else {
					dateDepartHidden.value = '';
					selectFlexibilite.value = null;
					//selectFlexibilite.setAttribute('disabled', true);
					self._deleteDate(filtres.json);
				}
			},
			// onHide: instance => {
			// 	console.log('Calendar hidden.')
			// },
			// Customizations.
			// formatter: (input, date, instance) => {
			// 	// This will display the date as `1/1/2019`.
			// 	//input.value = date.toDateString();
			// },
		}

		const picker = selectorCalendar !== null ? datepicker(selectorCalendar, options) : '';
	}

	_getDate(obj) {
		let currentDate = document.getElementById('dateDepartHidden').value,
			newData = {
				'filtre': 'date',
				'value': currentDate
			};
		// On supprime la date précédente
		for (var i = obj.length - 1; i >= 0; i--) {
			if (obj[i].filtre === 'date') {
				obj.splice(i, 1);
			}
		}
		// On met à jour le json
		obj.push(newData);
	}

	_deleteDate(obj) {
		// On supprime la date renseignée
		// et la flexibilité
		// dans {obj}
		for (var i = obj.length - 1; i >= 0; i--) {
			if (obj[i].filtre === 'date') {
				obj.splice(i, 1);
			} else if (obj[i].filtre === 'flexibilite') {
				obj.splice(i, 1);
			}
		}
		// On reload les résultats
		const filtringClass = new filtring();
		filtringClass.reloadResultat();
	}
}